import axios from 'axios';
import { msalInstance } from '../authConfig';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://stage.api.eyepax.info';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to add auth token
api.interceptors.request.use(async (config: any) => {
  const account = msalInstance.getActiveAccount();
  if (account && config.headers) {
    const response = await msalInstance.acquireTokenSilent({
      scopes: ['User.Read'],
      account: account,
    });

    config.headers.Authorization = `Bearer ${response.idToken}`;
  }
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error);
    // if (error.response?.status === 401) {
    //   // Handle unauthorized access
    //   msalInstance.logoutRedirect();
    // }
    return Promise.reject(error);
  }
);

export default api; 